/* eslint-disable no-mixed-operators */
import * as React from "react";
import Template, { renderSpinnerWithLabel } from "../../../../core/libraries/Template";
import { connect } from "react-redux";
import { RootState } from "../../../../store/store";
import { Link, Icon, Label, Spinner, SpinnerSize, Text } from "@fluentui/react";
import Helper from "../../../../core/libraries/Helper";
import Constants from "../../../../core/libraries/Constants";
import {
  updateProperty,
  updateFirstLoadCheck,
} from "../../actions";
import DatePicker from "../../../../core/components/DatePickerWithErrorController";
import {
  changeDepartmentDispatch,
  changeDivisionAdminDispatch,
  changeSPFOwnerDispatch
} from "../../thunks";
import FilePicker from "../../../../core/components/FilePicker";
import RbTextField from "../../../../bosch-react/components/text-field/RbTextField";
import RbLabel from "../../../../bosch-react/components/label/RbLabel";
import "../../../../core/scss/_customize.scss";
import { IUserProfile } from "../../../Auth/types";
import { showDialog, showToastMessage, confirmDialog } from "../../../Dialog/actions";
import { downloadReport } from "../../../../services/commonServices";
import { IAccessMediator, ReportStatus } from "../../types";
import CustomizedPeoplePicker from "../../../../core/components/PeoplePicker/CustomizedPeoplePicker";
import { PrincipalType } from "../../../../core/components/PeoplePicker/types";
import { removeAliasDomain } from "../../../../utils/converter";
import { IGetOrgInfoReq, QueryTypeEnums } from "../../../../services/type";
import { TextField } from "office-ui-fabric-react";
import { IDownloadedStatistic, StatisticType, insertStatisticData } from "../../../Statistics/services";
import { getLLDivisionAdmin } from "../../../../services/aadServices";

interface ILeftColumnProps {
  userProfile: IUserProfile | undefined;
  accessMediator: IAccessMediator;
  showDialog: typeof showDialog;
  showToastMessage: typeof showToastMessage;
  confirmDialog: typeof confirmDialog;
  updateProperty: typeof updateProperty;
  updateFirstLoadCheck: typeof updateFirstLoadCheck;
  changeDivisionAdminDispatch: any;
  changeDepartmentDispatch: any;
  changeSPFOwnerDispatch: any;
  // from parent
  hasAdminPermission: boolean | undefined;
}

interface ILeftColumnState {
  isDownloading: boolean,
}

class LeftColumn extends React.Component<ILeftColumnProps, ILeftColumnState> {
  authorsRef: React.RefObject<any> = React.createRef();
  approverRef: React.RefObject<any> = React.createRef();
  changeDepartmentRef: React.RefObject<any> = React.createRef();
  changeSPFOwnerRef: React.RefObject<any> = React.createRef();

  async componentDidMount() {
    if (this.props.accessMediator.report.uploadType === Constants.UPLOAD_TYPE.LL) {
      this.props.changeDivisionAdminDispatch(this.props.accessMediator.report.division, undefined)
    }
  }

  constructor(props: ILeftColumnProps) {
    super(props);
    this.state = {
      isDownloading: false
    };
    this.renderTitle = this.renderTitle.bind(this);
    this.renderAttachment = this.renderAttachment.bind(this);
    this.renderAttachedUrl = this.renderAttachedUrl.bind(this);
    this.renderAuthors = this.renderAuthors.bind(this);
    this.renderROU = this.renderROU.bind(this);
    this.renderPortfolio = this.renderPortfolio.bind(this);
    this.renderApproverForBSH = this.renderApproverForBSH.bind(this);
    this.renderChangeDepartment = this.renderChangeDepartment.bind(this);
    this.renderchangeSPFOwner = this.renderchangeSPFOwner.bind(this);
    this.renderLLDivisionAdmin = this.renderLLDivisionAdmin.bind(this);
    this.renderSubmitter = this.renderSubmitter.bind(this);
    this.renderKeywords = this.renderKeywords.bind(this);
    this.renderReportDate = this.renderReportDate.bind(this);
    this.renderDivision = this.renderDivision.bind(this);
    this.renderDepartment = this.renderDepartment.bind(this);
    this.openAMFile = this.openAMFile.bind(this);
    this.generateFileName = this.generateFileName.bind(this);
  }

  render() {
    return (
      <div className="ms-Grid">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-lg12 ms-xl11">
            {this.renderTitle()}
            {this.renderAttachment()}
            {this.renderAttachedUrl()}
            {this.renderAuthors()}
            {this.renderAuthorDisplayName()}
            {this.renderChangeDepartment()}
            {this.renderDivision()}
            {this.renderDepartment()}
            {this.renderROU()}
            {this.renderchangeSPFOwner()}
            {this.renderPortfolio()}
            {this.renderLLDivisionAdmin()}
            {this.renderSubmitter()}
            {this.renderKeywords()}
            {this.renderReportDate()}
          </div>
          <div className="ms-Grid-col ms-lg0 ms-xl1" />
        </div>
      </div>
    );
  }

  renderTitle() {
    return Template.renderAccessMediatorRowTemplate(
      this.props.accessMediator.mode,
      "Title",
      <span className="textarea-transparent">
        <RbLabel isMultipleLines={true} maxLines={10} hasPadding={true}>
          {this.props.accessMediator.report.title}
        </RbLabel>
      </span>,
      <RbTextField
        value={this.props.accessMediator.report.title}
        onChange={(event: React.ChangeEvent<any>) => {
          this.props.updateProperty("title", event.currentTarget.value);
        }}

      />,
      null,
      Helper.setEmptyIfNull(this.props.accessMediator.validation.title)
    );
  }


  renderAttachment() {
    let hasAttachment = this.props.accessMediator.report.hasAttachment;
    if (
      this.props.accessMediator.report.uploadType !== Constants.UPLOAD_TYPE.Paper ||
      (this.props.accessMediator.report.uploadType === Constants.UPLOAD_TYPE.Paper &&
        this.props.accessMediator.report.attachedUrl === "" &&
        this.props.accessMediator.mode === Constants.ACCESS_MEDIATOR_MODE.VIEW)
    ) {
      let element = hasAttachment === undefined ?
        <>
          <Label>Small spinner</Label>
          <Spinner size={SpinnerSize.small} />
        </> :
        <div>
          <div
            className="attachment-button"
            onClick={() => {
              if (!!hasAttachment && !this.state.isDownloading) {
                this.setState({ isDownloading: true })
                this.openAMFile();
              }
            }}
          >
            {this.state.isDownloading &&
              <div>
                <Spinner size={SpinnerSize.large}
                  styles={{ label: { color: 'white', fontSize: '1rem' } }}
                  label="Preparing..." ariaLive="assertive" labelPosition="left" />
              </div>
              ||
              <>
                <Icon
                  iconName={
                    !!hasAttachment
                      ? "Download"
                      : "StatusCircleErrorX"
                  }
                />
                &nbsp;&nbsp;&nbsp;
                <span style={{ wordBreak: "break-word" }}>
                  {!!hasAttachment
                    ? this.generateFileName()
                    : "Missed document"}
                </span>
              </>}
          </div>
        </div>
      return Template.renderAccessMediatorRowTemplate(
        this.props.accessMediator.mode,
        "Attachment",
        element,
        <React.Fragment>
          {element}
          <FilePicker
            text="Change file"
            onFileChange={(file: any) => {
              this.props.updateProperty("attachment", file);
            }}
          />
        </React.Fragment>
      );
    }
    return null;
  }

  handleOnclickAttachedUrl = () => {
    Helper.runNewTask(async () => {
      const downloadedStatisticRecord: IDownloadedStatistic = {
        reportGuid: this.props.accessMediator.report.guid,
        department: this.props.userProfile?.department || "",
        division: this.props.userProfile?.division || "",
        createdBy: this.props.userProfile?.name || "",
        securityClass: this.props.accessMediator.report.securityClass
      }
      await insertStatisticData(StatisticType.Downloaded, downloadedStatisticRecord)
    })
  }

  renderAttachedUrl() {
    const { attachedUrl } = this.props.accessMediator.report
    if (this.props.accessMediator.report.uploadType === Constants.UPLOAD_TYPE.Paper) {
      return Template.renderAccessMediatorRowTemplate(
        this.props.accessMediator.mode,
        "Url",
        <div style={{ width: "100%", wordBreak: "break-all" }}>
          {!!attachedUrl && <Link
            target="_blank"
            href={attachedUrl} onClick={() => { this.handleOnclickAttachedUrl() }}>
            {attachedUrl}
          </Link> || <Text>No attached URL</Text>}
        </div>,
        <RbTextField
          value={attachedUrl ?? ""}
          onChange={(event: React.ChangeEvent<any>) => {
            this.props.updateProperty("attachedUrl", event.currentTarget.value);
          }}
        />,
        null,
        Helper.setEmptyIfNull(this.props.accessMediator.validation.attachedUrl)
      );
    }
    return null;
  }

  handleOnChangeAuthors = () => {
    let items = this.authorsRef.current.getSelectedItems();
    let results: any[] = [];
    items.forEach((item: any) => {
      !!item.loginName && results.push(removeAliasDomain(item.loginName));
    });
    this.props.updateProperty("authors", results);
  }

  renderAuthors() {
    return Template.renderAccessMediatorRowTemplate(
      this.props.accessMediator.mode,
      "Authors",
      Template.renderReadOnlyPeople(
        this.props.accessMediator.report.authors
      ),
      <CustomizedPeoplePicker
        principalType={PrincipalType.People}
        objectIds={this.props.accessMediator.report.authors}
        componentRef={this.authorsRef}
        itemLimit={this.props.hasAdminPermission === true ? 20 : 10}
        onChange={() => this.handleOnChangeAuthors()}
        errorMessage={this.props.accessMediator.validation.authors} />
    );
  }

  renderAuthorDisplayName() {
    const { report } = this.props.accessMediator;

    const shouldShowField =
      report.uploadType !== Constants.UPLOAD_TYPE.Paper &&
      (
        this.props.accessMediator.mode === Constants.ACCESS_MEDIATOR_MODE.EDIT ||
        (report.authorDisplayName && report.authorDisplayName.trim() !== "")
      );

    if (shouldShowField) {
      return Template.renderAccessMediatorRowTemplate(
        this.props.accessMediator.mode,
        "Author display name",
        <span className="textarea-transparent">
          <RbLabel isMultipleLines={true} maxLines={10} hasPadding={true}>
            {report.authorDisplayName}
          </RbLabel>
        </span>,
        <RbTextField
          value={report.authorDisplayName ?? ""}
          onChange={(event: React.ChangeEvent<any>) => {
            this.props.updateProperty("authorDisplayName", event.currentTarget.value);
          }}
        />,
        null,
        Helper.setEmptyIfNull(this.props.accessMediator.validation.authorDisplayName)
      );
    }

    return null;
  }



  renderROU() {
    let { rou } = this.props.accessMediator.report
    if (
      this.props.hasAdminPermission === true ||
      (this.props.accessMediator.status !== ReportStatus.PUBLISHED &&
        this.props.accessMediator.mode === Constants.ACCESS_MEDIATOR_MODE.EDIT)
    ) {
      return Template.renderAccessMediatorRowTemplate(
        this.props.accessMediator.mode,
        "Approver",
        !!rou && Template.renderReadOnlyPeople(
          [rou], undefined, true
        ),
        this.props.accessMediator.report.uploadType === Constants.UPLOAD_TYPE.LL &&
          this.props.accessMediator.report.division === "BSH"
          ? this.renderApproverForBSH() // Exception for BSH
          : !!rou && Template.renderReadOnlyPeople(
            [rou], undefined, true
          ),
        this.renderIsLoadingROU(),
        this.props.accessMediator.validation.rou
      );
    }
    return null;
  }

  renderPortfolio() {
    let { spfManager } = this.props.accessMediator.report
    if (
      this.props.accessMediator.report.division === "CR" &&
      this.props.accessMediator.report.uploadType === Constants.UPLOAD_TYPE.RnD
    ) {
      if (
        this.props.hasAdminPermission === true ||
        (this.props.accessMediator.status !== ReportStatus.PUBLISHED &&
          this.props.accessMediator.mode === Constants.ACCESS_MEDIATOR_MODE.EDIT)
      ) {
        return Template.renderAccessMediatorRowTemplate(
          this.props.accessMediator.mode,
          "Strategic Portfolio Owner",
          !!spfManager && Template.renderReadOnlyPeople([spfManager], undefined, true),
          !!spfManager && Template.renderReadOnlyPeople([spfManager], undefined, true),
          this.renderIsLoadingSPFOwner()
        );
      }
      return null;
    }
  }

  handleOnChangeApproverForBSH = () => {
    let items = this.approverRef.current.getSelectedItems();
    let results: any[] = [];
    items.forEach((item: any) => {
      !!item.loginName && results.push(removeAliasDomain(item.loginName));
    });
    this.props.updateProperty(
      "rou",
      results.length === 0 ? null : results[0]
    );
  }

  renderApproverForBSH() {
    return (
      <CustomizedPeoplePicker
        principalType={PrincipalType.People}
        itemLimit={1}
        defaultValue={[]}
        componentRef={this.approverRef}
        onChange={this.handleOnChangeApproverForBSH}
        errorMessage={this.props.accessMediator.validation.rou}
      />
    );
  }


  alertInvalidSPO() {
    this.props.confirmDialog(Constants.CONFIRMATION_MESSAGE.NOT_CR_GROUP.TITLE,
      Constants.CONFIRMATION_MESSAGE.NO_GM.CONTENT + " Or " + Constants.CONFIRMATION_MESSAGE.NOT_CR_GROUP.CONTENT
      , true, () => { });
  }

  renderIsLoadingSPFOwner() {
    if (this.props.accessMediator.isSPFOLoading) {
      return renderSpinnerWithLabel("Strategic Portfolio Owner is being validated...");
    }
    return null;
  }

  handleOnchangeSPFOwner = async () => {
    const { changeSPFOwnerDispatch } = this.props;
    let items = this.changeSPFOwnerRef.current.getSelectedItems();
    console.log("Change SPF Owner - selected items: ", items);
    if (items.length > 0) {
      let getOrgReq: IGetOrgInfoReq = {
        identitiesOrOrgNames: [items[0].displayName],
        queryType: QueryTypeEnums.OrgNames
      }
      changeSPFOwnerDispatch(getOrgReq, (result: any) => {
        if (!result) {
          this.alertInvalidSPO();
        }
      })
    }
  }

  renderchangeSPFOwner() {
    const { mode, status, report } = this.props.accessMediator
    if (
      mode === Constants.ACCESS_MEDIATOR_MODE.EDIT &&
      status !== ReportStatus.PUBLISHED &&
      status !== ReportStatus.PENDING &&
      report.division === "CR" &&
      report.uploadType === Constants.UPLOAD_TYPE.RnD
    ) {
      return Template.renderAccessMediatorRowTemplate(
        mode,
        "Change SPF Owner",
        null,
        <CustomizedPeoplePicker
          principalType={PrincipalType.Group}
          itemLimit={1}
          componentRef={this.changeSPFOwnerRef}
          onChange={this.handleOnchangeSPFOwner}
          isRequired={true}
          errorMessage={this.props.accessMediator.validation.spfManager}
        />
      );
    }
    return null;
  }

  alertNoDepartmentFound() {
    this.props.confirmDialog(Constants.CONFIRMATION_MESSAGE.NO_ROU.TITLE,
      Constants.CONFIRMATION_MESSAGE.NO_ROU.CONTENT, true, () => { });
  }

  handleOnchangeDepartment = async () => {
    const { accessMediator, changeDepartmentDispatch, changeDivisionAdminDispatch } = this.props;
    let items = this.changeDepartmentRef.current.getSelectedItems();
    if (items.length > 0) {
      let getOrgReq: IGetOrgInfoReq = {
        identitiesOrOrgNames: [items[0].displayName],
        queryType: QueryTypeEnums.OrgNames
      }
      !!this.changeSPFOwnerRef.current && this.changeSPFOwnerRef.current.setItems([]); // Clear SPF Owner field when department changed
      changeDepartmentDispatch(getOrgReq, (result: any) => {
        if (!result) {
          this.alertNoDepartmentFound();
          return;
        }
        if (accessMediator.report.uploadType === Constants.UPLOAD_TYPE.LL) {
          changeDivisionAdminDispatch(result.division)
        }
      })
    }
  }

  renderChangeDepartment() {
    if (
      this.props.accessMediator.mode === Constants.ACCESS_MEDIATOR_MODE.EDIT &&
      this.props.accessMediator.status !== ReportStatus.PUBLISHED &&
      this.props.accessMediator.status !== ReportStatus.PENDING &&
      // Exception for BSH: Not showing this field if restart
      !(
        this.props.accessMediator.report.uploadType === Constants.UPLOAD_TYPE.LL &&
        this.props.accessMediator.report.division === "BSH"
      )
    ) {
      return Template.renderAccessMediatorRowTemplate(
        this.props.accessMediator.mode,
        "Change department",
        null,
        <CustomizedPeoplePicker
          principalType={PrincipalType.Group}
          itemLimit={1}
          componentRef={this.changeDepartmentRef}
          onChange={this.handleOnchangeDepartment}
        />
      );
    }
    return null;
  }

  renderIsLoadingLLDivAdmin() {
    if (this.props.accessMediator.isLLCoordinatorLoading) {
      return renderSpinnerWithLabel("Lessons learned Coordinator is being validated...");
    }
    return null;
  }

  renderLLDivisionAdmin() {
    const { uploadType, llDivisionAdmin } = this.props.accessMediator.report
    if (uploadType === Constants.UPLOAD_TYPE.LL) {
      return Template.renderAccessMediatorRowTemplate(
        this.props.accessMediator.mode,
        "Divisional lessons learned coordinator",
        !!llDivisionAdmin && Template.renderReadOnlyPeople(
          [llDivisionAdmin], undefined, true
        ) || <RbLabel isMultipleLines={true} maxLines={10} hasPadding={true}>No Divisional lessons learned coordinator assigned</RbLabel>,
        !!llDivisionAdmin && Template.renderReadOnlyPeople(
          [llDivisionAdmin], undefined, true
        ) || <RbLabel isMultipleLines={true} maxLines={10} hasPadding={true}>No Divisional lessons learned coordinator assigned</RbLabel>,
        this.renderIsLoadingLLDivAdmin()
      );
    }
    return null;
  }

  renderSubmitter() {
    const { createdBy } = this.props.accessMediator.report
    return Template.renderAccessMediatorRowTemplate(
      this.props.accessMediator.mode,
      "Submitter",
      !!createdBy && Template.renderReadOnlyPeople(
        [createdBy]
      ),
      !!createdBy && Template.renderReadOnlyPeople(
        [createdBy]
      )
    );
  }

  renderKeywords() {
    return Template.renderAccessMediatorRowTemplate(
      this.props.accessMediator.mode,
      "Keywords",
      <span className="textarea-transparent">
        <RbLabel isMultipleLines={true} maxLines={10} hasPadding={true}>
          {this.props.accessMediator.report.keywords}
        </RbLabel>
      </span>,
      <RbTextField
        minRows={5}
        isMultiple={true}
        value={this.props.accessMediator.report.keywords}
        onChange={(event: React.ChangeEvent<any>) => {
          this.props.updateProperty("keywords", event.currentTarget.value);
        }}
      />,
      Helper.setEmptyIfNull(this.props.accessMediator.validation.keywords)
    );
  }

  renderReportDate() {
    return Template.renderAccessMediatorRowTemplate(
      this.props.accessMediator.mode,
      "Report date",
      <span className="textarea-transparent">
        <RbLabel hasPadding={true}>
          {Helper.getDateTimeFormatForUI(this.props.accessMediator.report.documentDate)}
        </RbLabel>
      </span>,
      <DatePicker
        value={Helper.parseDate(this.props.accessMediator.report.documentDate)}
        onSelectDate={(date: Date) => {
          const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
          this.props.updateProperty("documentDate", utcDate);
        }}
        errorMessage={this.props.accessMediator.validation.documentDate}
      />
    );
  }

  renderIsLoadingROU() {
    if (this.props.accessMediator.isROULoading) {
      return renderSpinnerWithLabel();
    }
    return null;
  }

  renderDivision = () => Template.renderAccessMediatorRowTemplate(
    this.props.accessMediator.mode,
    "Division",
    <RbLabel hasPadding={true}>
      {this.props.accessMediator.report.division}
    </RbLabel>,
    <TextField
      disabled
      value={this.props.accessMediator.report.division}
      onChange={(event: React.ChangeEvent<any>) => {
        this.props.updateProperty(
          "department",
          event.currentTarget.value
        );
      }}
    />,
    this.renderIsLoadingROU()
  );

  renderDepartment = () =>
    Template.renderAccessMediatorRowTemplate(
      this.props.accessMediator.mode,
      "Department",
      <RbLabel hasPadding={true}>
        {this.props.accessMediator.report.department}
      </RbLabel>,
      <TextField
        disabled
        value={this.props.accessMediator.report.department}
        onChange={(event: React.ChangeEvent<any>) => {
          this.props.updateProperty(
            "department",
            event.currentTarget.value
          );
        }}
      />,
      this.renderIsLoadingROU()
    );
  downloadNewAttachment(file: File) {
    try {
      // Create a blob URL for the file
      const url = URL.createObjectURL(file);

      // Create a temporary anchor element to trigger download
      const link = document.createElement('a');
      link.href = url;
      link.download = file.name || this.generateFileName();
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      this.props.showToastMessage(
        Constants.TOAST_MESSAGE_CODE.SUCCESS,
        "Download successfully!!!"
      );
    } catch (error) {
      this.props.showToastMessage(
        Constants.TOAST_MESSAGE_CODE.ERROR,
        "Failed to download new attachment"
      );
    }
  }

  async openAMFile() {
    try {
      const newAttachment = this.props.accessMediator.report.attachment;
      // If there's a new attachment file, download it directly
      if (newAttachment && newAttachment instanceof File) {
        this.downloadNewAttachment(newAttachment);
      } else {
        // Otherwise, download the existing file from server
        let isSuccess = await downloadReport(
          this.props.accessMediator.report.id,
          `${this.props.accessMediator.report.guid}.pdf`,
          this.generateFileName()
        );
        if (!!isSuccess) {
          Helper.runNewTask(async () => {
            const downloadedStatisticRecord: IDownloadedStatistic = {
              reportGuid: this.props.accessMediator.report.guid,
              department: this.props.userProfile?.department || "",
              division: this.props.userProfile?.division || "",
              createdBy: this.props.userProfile?.name || "",
              securityClass: this.props.accessMediator.report.securityClass
            }
            await insertStatisticData(StatisticType.Downloaded, downloadedStatisticRecord)
          })
          this.props.showToastMessage(
            Constants.TOAST_MESSAGE_CODE.SUCCESS,
            "Download successfully!!!"
          );
        }
        else {
          this.props.showToastMessage(
            Constants.TOAST_MESSAGE_CODE.ERROR,
            "No attachment found"
          );
        }
      }
    }
    catch (error) { }
    finally {
      this.setState({ isDownloading: false })
    }
  }
  generateFileName() {
    const newAttachment = this.props.accessMediator.report.attachment;

    // If there's a new attachment, use its name
    if (newAttachment && newAttachment instanceof File && newAttachment.name) {
      return newAttachment.name;
    }

    // Otherwise, generate filename from report data
    return Helper.generateNameFileForDownload(
      this.props.accessMediator.report.title,
      this.props.accessMediator.report.documentNumber ?? ""
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  userProfile: state.auth.userProfile,
  accessMediator: state.accessMediator,
});

export default connect(mapStateToProps, {
  showDialog,
  showToastMessage,
  confirmDialog,
  updateProperty,
  changeDivisionAdminDispatch,
  changeDepartmentDispatch,
  changeSPFOwnerDispatch,
  updateFirstLoadCheck,
})(LeftColumn);
